import { getUserProfileById } from "../../services/api";
import * as types from "../types";

const userProfileRequest = () => ({ type: types.USER_PROFILE_REQUEST });
export const userProfileSuccess = (data) => ({
  type: types.USER_PROFILE_SUCCESS,
  payload: data,
});
const userProfileFailure = (error) => ({
  type: types.USER_PROFILE_FAILURE,
  payload: error,
});

export const getUserProfileByIdAction = (userId) => {
  return async (dispatch) => {
    dispatch(userProfileRequest());
    try {
      const response = await getUserProfileById(userId);
      dispatch(userProfileSuccess(response.data));
    } catch (error) {
      dispatch(userProfileFailure(error.message));
    }
  };
};

export const editUserProfileAction = (userData) => ({
  type: types.EDIT_USER_PROFILE_SUCCESS,
  payload: userData,
});

export const logout = () => ({
  type: types.LOGOUT,
});

export const setCheckboxLinkedWheel = (checkboxValue) => ({
  type: types.SET_CHECKBOX_LINKED_WHEEL,
  payload: checkboxValue,
});

export const setReportModalOpen = (modalStatus) => ({
  type: types.SET_REPORT_MODAL_OPEN,
  payload: modalStatus,
});

export const setReportInstance = (instance) => ({
  type: types.SET_REPORT_INSTANCE,
  payload: instance,
});

export const setReportLocation = (location) => ({
  type: types.SET_REPORT_LOCATION,
  payload: location,
});
